var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoyObyCnp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206.472,
    height: 14,
    viewBox: "0 0 206.472 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_327",
    "data-name": "Rect\\xE1ngulo 327",
    width: 178.298,
    height: 11.412,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YOYO_by_CNP",
    "data-name": "YOYO by CNP",
    transform: "translate(-885.92 -680.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BY_-_text",
    "data-name": "BY - text",
    transform: "translate(886.92 141.454)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "by",
    transform: "translate(7 550.427)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "InstrumentSans-Bold, Instrument Sans",
    fontWeight: 700,
    letterSpacing: "0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.463,
    y: 0
  }, "BY"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_972",
    "data-name": "Grupo 972",
    transform: "translate(914.094 682.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_971",
    "data-name": "Grupo 971",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1055",
    "data-name": "Trazado 1055",
    d: "M4.42,3.711a2.2,2.2,0,0,1,.8-.546,2.787,2.787,0,0,1,1.045-.187,2.6,2.6,0,0,1,1.317.335,3.774,3.774,0,0,1,1.068.943l2.323-2.073A5.282,5.282,0,0,0,8.925.562,6.832,6.832,0,0,0,6.08,0,6.925,6.925,0,0,0,3.656.414,5.707,5.707,0,0,0,1.723,1.591,5.359,5.359,0,0,0,.452,3.4,5.745,5.745,0,0,0,0,5.707,5.743,5.743,0,0,0,.452,8.014,5.354,5.354,0,0,0,1.723,9.822,5.7,5.7,0,0,0,3.656,11a6.925,6.925,0,0,0,2.424.413,6.749,6.749,0,0,0,2.845-.569,5.406,5.406,0,0,0,2.05-1.614L8.652,7.157A3.769,3.769,0,0,1,7.585,8.1a2.6,2.6,0,0,1-1.317.335,2.791,2.791,0,0,1-1.045-.187,2.2,2.2,0,0,1-.8-.546A2.534,2.534,0,0,1,3.9,6.837a3.244,3.244,0,0,1-.187-1.13A3.245,3.245,0,0,1,3.9,4.577a2.537,2.537,0,0,1,.522-.865",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1056",
    "data-name": "Trazado 1056",
    d: "M72.664,1.614A5.805,5.805,0,0,0,70.715.421a7.394,7.394,0,0,0-4.919,0A5.788,5.788,0,0,0,63.84,1.614a5.5,5.5,0,0,0-1.286,1.808,5.568,5.568,0,0,0-.46,2.284,5.581,5.581,0,0,0,.46,2.276A5.476,5.476,0,0,0,63.84,9.8,5.788,5.788,0,0,0,65.8,10.991a7.394,7.394,0,0,0,4.919,0A5.805,5.805,0,0,0,72.664,9.8,5.482,5.482,0,0,0,73.95,7.982a5.587,5.587,0,0,0,.46-2.276,5.574,5.574,0,0,0-.46-2.284,5.5,5.5,0,0,0-1.286-1.808M70.513,6.852a2.453,2.453,0,0,1-.522.857,2.308,2.308,0,0,1-.779.538,2.551,2.551,0,0,1-1.918,0,2.307,2.307,0,0,1-.78-.538,2.45,2.45,0,0,1-.522-.857A3.293,3.293,0,0,1,65.8,5.706a3.294,3.294,0,0,1,.187-1.146,2.45,2.45,0,0,1,.522-.857,2.3,2.3,0,0,1,.78-.538,2.551,2.551,0,0,1,1.918,0,2.305,2.305,0,0,1,.779.538,2.453,2.453,0,0,1,.522.857A3.294,3.294,0,0,1,70.7,5.706a3.293,3.293,0,0,1-.187,1.146",
    transform: "translate(-50.729 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1057",
    "data-name": "Trazado 1057",
    d: "M144.895,1.614A5.805,5.805,0,0,0,142.946.421a7.394,7.394,0,0,0-4.919,0,5.789,5.789,0,0,0-1.957,1.193,5.5,5.5,0,0,0-1.286,1.808,5.568,5.568,0,0,0-.46,2.284,5.581,5.581,0,0,0,.46,2.276A5.476,5.476,0,0,0,136.071,9.8a5.789,5.789,0,0,0,1.957,1.193,7.394,7.394,0,0,0,4.919,0A5.805,5.805,0,0,0,144.895,9.8a5.481,5.481,0,0,0,1.286-1.816,5.587,5.587,0,0,0,.46-2.276,5.573,5.573,0,0,0-.46-2.284,5.5,5.5,0,0,0-1.286-1.808m-2.151,5.238a2.453,2.453,0,0,1-.522.857,2.308,2.308,0,0,1-.779.538,2.551,2.551,0,0,1-1.918,0,2.308,2.308,0,0,1-.78-.538,2.45,2.45,0,0,1-.522-.857,3.293,3.293,0,0,1-.187-1.146,3.294,3.294,0,0,1,.187-1.146,2.45,2.45,0,0,1,.522-.857,2.305,2.305,0,0,1,.78-.538,2.551,2.551,0,0,1,1.918,0,2.305,2.305,0,0,1,.779.538,2.453,2.453,0,0,1,.522.857,3.293,3.293,0,0,1,.187,1.146,3.292,3.292,0,0,1-.187,1.146",
    transform: "translate(-109.74 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1058",
    "data-name": "Trazado 1058",
    d: "M212.62,1.363h-3.679V12.276h8.606V9.423H212.62Z",
    transform: "translate(-170.699 -1.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1059",
    "data-name": "Trazado 1059",
    d: "M300.676,10.836l-7.421-9.473h-.67V12.276h.8V2.8l7.436,9.474h.655V1.363h-.8Z",
    transform: "translate(-239.035 -1.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1060",
    "data-name": "Trazado 1060",
    d: "M362.715,7.084h5.815v-.7h-5.815V2.08h6.5V1.363h-7.3V12.276h7.53v-.717h-6.735Z",
    transform: "translate(-295.68 -1.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1061",
    "data-name": "Trazado 1061",
    d: "M425.171,8.261A3.434,3.434,0,0,0,426.683,7a3.522,3.522,0,0,0,.53-1.957,3.58,3.58,0,0,0-.53-1.988A3.386,3.386,0,0,0,425.171,1.8a5.773,5.773,0,0,0-2.354-.437H418.9V12.276h.8V8.706h3.118a7.133,7.133,0,0,0,1.052-.075l2.612,3.645h.9l-2.736-3.818a4.384,4.384,0,0,0,.522-.2M419.7,8V2.08h3.118a4.043,4.043,0,0,1,2.674.772,2.711,2.711,0,0,1,.912,2.19,2.716,2.716,0,0,1-.912,2.183A4.013,4.013,0,0,1,422.817,8Z",
    transform: "translate(-342.235 -1.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1062",
    "data-name": "Trazado 1062",
    d: "M487.589,2.065a6.34,6.34,0,0,0-3.04-.7h-4.318V12.276h4.318a6.342,6.342,0,0,0,3.04-.7,5.1,5.1,0,0,0,2.034-1.933,5.457,5.457,0,0,0,.725-2.822A5.457,5.457,0,0,0,489.624,4a5.1,5.1,0,0,0-2.034-1.933m1.341,7.21a4.387,4.387,0,0,1-1.762,1.676,5.608,5.608,0,0,1-2.681.608h-3.461V2.08h3.461a5.608,5.608,0,0,1,2.681.608,4.388,4.388,0,0,1,1.762,1.676,4.781,4.781,0,0,1,.623,2.455,4.781,4.781,0,0,1-.623,2.455",
    transform: "translate(-392.337 -1.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1063",
    "data-name": "Trazado 1063",
    d: "M546.828,1.363l-3.944,6.426L538.94,1.363h-.873l4.4,7.162v3.75h.8V8.526l4.4-7.163Z",
    transform: "translate(-439.587 -1.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1064",
    "data-name": "Trazado 1064",
    d: "M625.519,1.862a6.429,6.429,0,0,0-2.642-.5h-5.254V12.276H621.3V9.594h1.575a6.341,6.341,0,0,0,2.642-.507,3.973,3.973,0,0,0,1.723-1.426,3.866,3.866,0,0,0,.608-2.182,3.9,3.9,0,0,0-.608-2.19,3.909,3.909,0,0,0-1.723-1.426m-1.746,4.552a1.607,1.607,0,0,1-1.13.343H621.3V4.2h1.341a1.608,1.608,0,0,1,1.13.343,1.22,1.22,0,0,1,.366.935,1.219,1.219,0,0,1-.366.935",
    transform: "translate(-504.583 -1.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1065",
    "data-name": "Trazado 1065",
    d: "M683.675,8.066h4.615V5.416h-4.615V4.138h5.254V1.363h-8.871V12.276h9.073V9.5h-5.456Z",
    transform: "translate(-555.591 -1.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1066",
    "data-name": "Trazado 1066",
    d: "M745.567,1.614A5.809,5.809,0,0,0,743.618.421a7.394,7.394,0,0,0-4.919,0,5.788,5.788,0,0,0-1.956,1.193,5.5,5.5,0,0,0-1.286,1.808A5.569,5.569,0,0,0,735,5.706a5.582,5.582,0,0,0,.46,2.276A5.473,5.473,0,0,0,736.743,9.8a5.788,5.788,0,0,0,1.956,1.193,7.394,7.394,0,0,0,4.919,0A5.809,5.809,0,0,0,745.567,9.8a5.483,5.483,0,0,0,1.286-1.816,5.588,5.588,0,0,0,.46-2.276,5.574,5.574,0,0,0-.46-2.284,5.506,5.506,0,0,0-1.286-1.808m-2.151,5.238a2.453,2.453,0,0,1-.522.857,2.308,2.308,0,0,1-.779.538,2.551,2.551,0,0,1-1.918,0,2.308,2.308,0,0,1-.779-.538,2.45,2.45,0,0,1-.522-.857,3.289,3.289,0,0,1-.187-1.146,3.29,3.29,0,0,1,.187-1.146,2.45,2.45,0,0,1,.522-.857,2.305,2.305,0,0,1,.779-.538,2.551,2.551,0,0,1,1.918,0,2.306,2.306,0,0,1,.779.538,2.453,2.453,0,0,1,.522.857,3.29,3.29,0,0,1,.187,1.146,3.289,3.289,0,0,1-.187,1.146",
    transform: "translate(-600.475 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1067",
    "data-name": "Trazado 1067",
    d: "M817.51,1.862a6.429,6.429,0,0,0-2.642-.5h-5.254V12.276h3.679V9.594h1.575a6.342,6.342,0,0,0,2.642-.507,3.972,3.972,0,0,0,1.723-1.426,3.866,3.866,0,0,0,.608-2.182,3.9,3.9,0,0,0-.608-2.19,3.908,3.908,0,0,0-1.723-1.426m-1.746,4.552a1.607,1.607,0,0,1-1.13.343h-1.341V4.2h1.341a1.608,1.608,0,0,1,1.13.343,1.22,1.22,0,0,1,.366.935,1.219,1.219,0,0,1-.366.935",
    transform: "translate(-661.435 -1.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1068",
    "data-name": "Trazado 1068",
    d: "M875.729,1.363h-3.679V12.276h8.606V9.423h-4.926Z",
    transform: "translate(-712.444 -1.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1069",
    "data-name": "Trazado 1069",
    d: "M928.221,9.5V8.067h4.615V5.416h-4.615V4.138h5.254V1.363H924.6V12.276h9.073V9.5Z",
    transform: "translate(-755.379 -1.114)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoyObyCnp);
export default __webpack_public_path__ + "static/media/YOYObyCNP.c0fd6a0f81fee215137ca0a78b288ff4.svg";
export { ForwardRef as ReactComponent };